import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: { width: '100%' },
})
